<script setup lang="ts">
defineProps({
  categories: {
    type: Array,
    required: true,
  },
});
</script>
<template>
  <div class="footer-categories">
    <nuxt-link
      v-for="({ link, name, icon }, i) in categories"
      :key="`footer-category${i}`"
      :to="link"
      class="footer-category heading-s"
    >
      <span>{{ name }}</span>
      <UiIcon
        :name="icon"
        :response-size="[20, 20, 22, 24, 24, 24]"
        class="image"
      />
    </nuxt-link>
  </div>
</template>

<style scoped lang="scss">
.footer-categories {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  font-weight: 800;
  @include fz(16, 20);
  color: white;
  //text-transform: uppercase;
  @include sm-block {
    margin-bottom: 28px;
  }
  @include md-block {
    //margin-bottom: 60px;
    @include fz(20, 24);
  }
  @include lg-block {
    margin-bottom: 48px;
  }

  .footer-category {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 12px;
    margin-right: 0;
    @include sm-block {
      display: inline-flex;
      align-items: center;
      align-content: center;
      width: fit-content;
      margin-right: 12px;
    }
    @include lg-block {
      margin-right: 12px;
      margin-bottom: 12px;
    }

    .image {
      margin-left: 9px;
      @include sm-block {
        margin-left: 12px;
      }
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
